import { Component, OnInit } from '@angular/core';
import { ColorEvent } from 'ngx-color';
import { ConfirmationService, MessageService, ToastMessageOptions } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import {  ManagesCategories } from './manages-categories';
import { ICategory } from 'core-lib';
import { Message } from 'primeng/message';



@Component({
    selector: 'lib-media-category-manager',
    templateUrl: './manages-categories.component.html',
    styleUrls: ['./manages-categories.component.scss'],
    standalone: false
})
export class CategoryManagerComponent implements OnInit {

  categories: ICategory[] = [];
  selectedCategory: ICategory;
  clonedCategories: { [s: string]: ICategory; } = {};
  delegate: ManagesCategories;
  avColors = [
    "#b3bac5",
    "#61bd4f",
    "#f2d600",
    "#ff9f1a",
    "#eb5a46",
    "#c377e0",
    "#0079bf",
    "#00c2e0",
    "#51e898",
    "#ff78cb",
    "#344563",
  ]

  constructor( private messageService: MessageService, private confirmationService: ConfirmationService, private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.delegate = this.dialogConfig.data.delegate as ManagesCategories;
    this.delegate.listCategories().subscribe((result) => {
      this.categories = result.map((cat) => { if (!cat.color) cat.color = this.avColors[0]; return cat; });
    });
  }

  /**
   * color pickers seems to be buggy with ngmodel
   * @param category 
   * @param event 
   */
  handleColorChange(category: ICategory, event: ColorEvent) {
    category.color = event.color.hex;
  }

  /**
   * edit row
   * @param category 
   */
  onRowEditInit(category: ICategory) {
    this.clonedCategories[category.id] = { ...category };
  }

  /**
   *  save to backend
   * @param product 
   * @param index 
   */
  onRowEditSave(product: ICategory, index: number) {
    let request = { ...product };
    delete request['id'];
    delete request['lastModificationDate'];
    this.delegate.saveCategory(product.id, request).subscribe(result => {
      if (result) {
        this.messageService.add({ severity: 'success', summary: $localize`:@@media-category-manager.saved:Entry saved` } as ToastMessageOptions);
        this.categories[index] = result;
      }
      const event = new CustomEvent('resource-category-updated');
      window.dispatchEvent(event);
      delete this.clonedCategories[product.id];
    });
  }

  /**
   * Add Categorie
   */
  addCategory() {
    const resourceCategory = { name: $localize`:@@media-category-manager.new.default-name: Category ${this.categories.length}`, color: this.avColors[0] } as ICategory
    this.delegate.createCategory(resourceCategory).subscribe(result => {
      if (result) {
        this.messageService.add({ severity: 'success', summary: $localize`:@@media-category-manager.saved:Category added` } as ToastMessageOptions);
        this.categories.unshift(result);
        this.categories = [...this.categories]
        const event = new CustomEvent('resource-category-created');
        window.dispatchEvent(event);
      }
    });
  }

  /**
   * Cancel the edit
   * @param product 
   * @param index 
   */
  onRowEditCancel(category: ICategory, index: number) {
    this.categories[index] = this.clonedCategories[category.id];
    delete this.clonedCategories[category.id];
  }

  /**
   * Delete Category
   * @param product 
   * @param index 
   */
  onRowDelete(category: ICategory, index: number)  {
   this.confirmationService.confirm({
      key: "category",
      header: $localize`:@@media-category-manager.delete.header:Delete category`,
      message: $localize`:@@media-category-manager.delete.message:Do you really want to delete category ${category.name} ? All references will be removed.`,
      acceptLabel: $localize`:@@media-category-manager.delete.buttons.yes:Delete`,
      rejectLabel: $localize`:@@media-category-manager.delete.buttons.cancel:Cancel`,
      acceptButtonStyleClass: 'p-button-danger',
      defaultFocus: 'none',
      accept: () => {
        this.delegate.deleteCategory(category.id).subscribe((result) => {
          if (result) {
            const message = $localize`:@@media-category-manager.delete.delete-ok:Category deleted`;
            this.messageService.add({ severity: 'success', detail: message });
            const index = this.categories.indexOf(category);
            this.categories.splice(index, 1);
            this.categories = [...this.categories];
            const event = new CustomEvent('resource-category-deleted');
            window.dispatchEvent(event);
          }
        });
      }
    });
  }
  getSelectedIndex(){
    if(this.selectedCategory){
      return this.categories.indexOf(this.selectedCategory);
    }
    return null;
  }
}
